import _ from 'lodash';

export const serializeJsonApiObject = (object) => {
  const { id, ...attributes } = object;
  return {
    id,
    attributes: _.mapKeys(attributes, (val, key) => _.snakeCase(key)),
  };
};
